var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.78,
    height: 17.419,
    viewBox: "0 0 14.78 17.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_571",
    "data-name": "Raggruppa 571",
    transform: "translate(-112 -1230.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_570",
    "data-name": "Raggruppa 570",
    transform: "translate(112 1230.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_190",
    "data-name": "Raggruppa 190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sottrazione_1",
    "data-name": "Sottrazione 1",
    d: "M7.428,4.51V0H.8A.794.794,0,0,0,0,.8V16.184a.794.794,0,0,0,.8.8H11.939a.794.794,0,0,0,.8-.8V5.306H8.225a.8.8,0,0,1-.8-.8ZM6.9,13.792v.8a.265.265,0,0,1-.266.266H6.1a.266.266,0,0,1-.266-.266v-.806A1.9,1.9,0,0,1,4.8,13.41a.266.266,0,0,1-.019-.4l.39-.372a.272.272,0,0,1,.336-.024.8.8,0,0,0,.425.124h.932a.417.417,0,0,0,.391-.437.433.433,0,0,0-.291-.422l-1.492-.448A1.5,1.5,0,0,1,4.42,9.989,1.477,1.477,0,0,1,5.835,8.494v-.8A.265.265,0,0,1,6.1,7.428h.531a.265.265,0,0,1,.266.266V8.5a1.9,1.9,0,0,1,1.04.376.266.266,0,0,1,.019.4l-.39.372a.272.272,0,0,1-.336.024.8.8,0,0,0-.425-.124H5.874a.417.417,0,0,0-.391.437.433.433,0,0,0,.291.422l1.492.448A1.5,1.5,0,0,1,8.313,12.3,1.476,1.476,0,0,1,6.9,13.791Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(120.979 1230.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_168",
    "data-name": "Tracciato 168",
    d: "M14.072,10.835a.532.532,0,1,1,.76.745L12,15.122a.532.532,0,0,1-.767.014L9.355,13.258a.532.532,0,1,1,.752-.752l1.486,1.485,2.465-3.14.014-.015Z",
    transform: "translate(-9.182 -10.676)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.6c6db6caca1cdda5d731db0eb27d0efd.svg";
export { ForwardRef as ReactComponent };